import { createBrowserHistory } from 'history';
import formPathWithSearchParams from "../utils/formPathWithSearchParams.js";
import { PUBLIC_URL } from "../config";

const appHistory = createBrowserHistory({ basename: PUBLIC_URL });

export const appHistoryPushWithSearchParams = (params, pathname = '') => {
    appHistory.push(formPathWithSearchParams(params, pathname));
}

export const appHistoryReplaceWithSearchParams = (params, pathname = '') => {
    appHistory.replace(formPathWithSearchParams(params, pathname));
}

export default appHistory;
